import { Modal } from 'antd';
import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import consultationImg from '&/assets/img/qrcode/wx-service.png';
import './index.scss';

const ConsultationModal = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => {
        return { show, hide };
    });

    useEffect(() => {}, []);

    useEffect(() => {
        if (visible) initModal();
    }, [visible]);

    const show = () => {
        setVisible(true);
    };
    const hide = () => {
        setVisible(false);
    };

    const initModal = () => {};

    return (
        <Modal
            className="consultation-modal"
            onClose={hide}
            visible={visible}
            width="348px"
            onOk={hide}
            onCancel={hide}
            footer={null}
            centered>
            <div className="consultation-modal-content">
                <h3>{intl.get('userCenter.clientAdvisors')}</h3>
                <p>{intl.get('userCenter.schemeConsultation')}</p>
                <img src={consultationImg} alt="" />
                <span>{intl.get('userCenter.scanCode')}</span>
            </div>
        </Modal>
    );
});

export default ConsultationModal;
